import { useTranslation } from "next-i18next";
import { useForm, FormProvider } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import { Modal } from "common/ui/Modal";
import { Stack } from "common/ui/Stack";
import { Paragraph } from "common/ui/Paragraph";
import { Input } from "common/ui/Input";
import { PhoneInput } from "common/ui/PhoneInput";

import { developerFeatureRequestSchema } from "common/features/account/validations/developerFeatureRequestSchema";
import type { DeveloperFeatureRequestSchema } from "common/features/account/validations/developerFeatureRequestSchema";

interface Props {
  close: () => void,
  onSuccess: () => void,
}

export const DeveloperFeatureRequestModal = ({ close, onSuccess }: Props) => {
  const { t } = useTranslation(["common", "validation"]);
  const methods = useForm<DeveloperFeatureRequestSchema>({
    mode: "onBlur",
    resolver: yupResolver(developerFeatureRequestSchema),
  });
  const {
    register,
    formState: { isSubmitting, errors },
    handleSubmit,
  } = methods;

  const [err, setErr] = useState("");

  const submitRequest = async (values: DeveloperFeatureRequestSchema) => {
    setErr("");

    try {
      // TODO Need endpoint to submit developer feature request

      onSuccess();
      close();
    } catch (err) {
      setErr(t("somethingWentWrong", { ns: "validation" }));
    }
  };

  return (
    <Modal
      title={t("developerFeatureRequestModal.unlock")}
      close={close}
      primaryAction={{
        text: t("common.submit"),
        onClick: handleSubmit(submitRequest),
      }}
      secondaryAction={{
        text: t("common.cancel"),
        onClick: close,
      }}
      isProcessing={isSubmitting}
      error={err}
    >
      <Stack direction="column" gap={16}>
        <Paragraph variant="p1">
          {t("developerFeatureRequestModal.fillOut")}
        </Paragraph>
        <Input
          label={t("developerFeatureRequestModal.companyName")}
          errors={errors}
          {...register("companyName")}
        />
        <FormProvider {...methods}>
          <PhoneInput
            label={t("developerFeatureRequestModal.companyPhone")}
            name="companyPhone"
          />
        </FormProvider>
      </Stack>
    </Modal>
  )
}
